import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { AvForm, AvInput, AvFeedback, AvGroup } from 'availity-reactstrap-validation';
import { Input, FormGroup } from 'reactstrap';
import { Spring, animated } from 'react-spring';

import { validateForm } from 'js/services/FormTools';
import { validateCurrency } from 'js/services/Regex';

import EditItemFormState from 'js/stores/forms/EditItemFormState';

import AddressInput from 'js/components/common/AddressInput';
import AddressFeedback from 'js/components/common/AddressInput/AddressFeedback';
import ImageUploader from 'js/components/core/ImageUploader';

import Container from './Container';
import Label from 'js/components/core/Label';
import CenterContent from './CenterContent';
import PriceInput from './PriceInput';
import MoneySign from './MoneySign';
import ErrorDisplay from './ErrorDisplay';
import SaveButton from './SaveButton';

import Title from './Title';
import Spinner from './Spinner';

@inject('page')
@observer
export default class EditItem extends Component {
  editItemForm = EditItemFormState.create({ alias: this.props.page.alias });
  form = React.createRef();

  formIsValid = () => {
    this.editItemForm.clearError().setWasSubmitted();
    return validateForm(this.form.current, () => this.editItemForm.item.address.hasAddress);
  };

  saveItem = () =>
    !this.editItemForm.isSaving && this.formIsValid() && this.editItemForm.save().then(this.props.afterSave);

  render() {
    const { isLoaded, isLoading, hasAddressError, error, setError, item, onUpload, isSaving } = this.editItemForm;
    const { setTitle, setPrice, setSize, title, price, size, address, alias, image } = item;
    const image_url = image.url;

    return (
      <Container>
        {isLoading ? (
          <Spinner />
        ) : !isLoaded ? (
          <ErrorDisplay>{error || 'Error loading item.'}</ErrorDisplay>
        ) : (
          <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
            {animation => (
              <animated.div style={animation}>
                <AvForm onValidSubmit={this.saveItem} ref={this.form}>
                  <Title>Edit item</Title>
                  <AvGroup>
                    <Label for="title">TITLE</Label>
                    <AvInput name="title" id="title" onChange={setTitle} value={title} required />
                    <AvFeedback>Please describe what your item is.</AvFeedback>
                  </AvGroup>

                  <CenterContent>
                    <div>
                      <AvGroup>
                        <Label for="price">PRICE</Label>
                        <MoneySign />
                        <PriceInput
                          name="price"
                          id="price"
                          type="number"
                          onChange={setPrice}
                          value={price}
                          required
                          validate={validateCurrency}
                        />
                        <AvFeedback>Please enter a price for your item.</AvFeedback>
                      </AvGroup>

                      <FormGroup>
                        <Label for="size">SIZE</Label>
                        <Input type="select" name="select" defaultValue={size} onChange={setSize}>
                          <option value="small">Small</option>
                          <option value="medium">Medium</option>
                          <option value="large">Large</option>
                          <option value="extra-large">Extra Large</option>
                        </Input>
                      </FormGroup>
                    </div>
                    <div>
                      <Label for="picture" float="left">
                        PICTURE
                      </Label>
                      <ImageUploader
                        image={image_url}
                        alias={alias}
                        setError={setError}
                        onUpload={onUpload}
                        size="calc(((3rem + 1.5rem + 0.75rem) * 2) - 1.25rem - .75rem)"
                      />
                    </div>
                  </CenterContent>

                  <FormGroup>
                    <Label for="address">SHIPPING ADDRESS</Label>
                    <AddressInput
                      name="address"
                      id="address"
                      showError={hasAddressError}
                      address={address}
                      onChange={address.setAddress}
                    />
                    <AddressFeedback>Please enter and then select your address.</AddressFeedback>
                  </FormGroup>
                  <AvInput
                    type="text"
                    name="address2"
                    id="address2"
                    value={address.address2 || ''}
                    onChange={address.setAddress2}
                    placeholder="Apt/suite (optional)"
                  />

                  <ErrorDisplay>{error}</ErrorDisplay>

                  <SaveButton type="submit" isLoading={isSaving}>
                    {isSaving ? 'Saving' : 'Save'}
                  </SaveButton>
                </AvForm>
              </animated.div>
            )}
          </Spring>
        )}
      </Container>
    );
  }
}
